import { NAMES_ES } from "../../assets/appConstants/constants";
import CopyToClipboard from "../common/CopyToClipboard";
import { TableColumn } from "../../models/dataTable.model";
import { Link } from "react-router-dom";
import './index.css'

const TableSchema: TableColumn[] = [
  { key: 'code', name: NAMES_ES.code, width: '10%' },
  { key: 'name', name: NAMES_ES.name, width: '15%' },
  { key: 'created_date', name: NAMES_ES.created_date, width: '15%' },
  { key: 'element_type', name: NAMES_ES.element_type, width: '10%' },
  { key: 'site', name: NAMES_ES.site, width: '15%' },
  { key: 'description', name: NAMES_ES.description, width: '35%' },
]

const columnId: string = 'code'
const rowDetailPath = '/element/view/'

const rowDataPreprocesor = (rowData: any, project_code: string): any => {

  return {
    ...rowData,
    code_render: (
      <div className='element-table-column-id'>
        <span>
          <Link className="element-table-column-id__link" to={`/${project_code}${rowDetailPath}${rowData.code}`}>
            {rowData.code}
          </Link>
        </span>

        <div className='element-table-column-id__copyicon'>
          <CopyToClipboard targetText={rowData.code as string} />
        </div>
      </div>
    ),
  }
}

const handleDoubleClickRow = (project_code: string, element_code: string, navigate: any) => {
  navigate(`/${project_code}${rowDetailPath}${element_code}`)
}

export { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow }